import { Extension } from "@tiptap/core";

/**
 * Extension to preserve class attributes on specific HTML elements
 * This is particularly useful for custom list types where we need to maintain
 * the class attributes after editor initialization
 *
 * https://github.com/ueberdosis/tiptap/issues/331
 */
export const AttributesPreserver = Extension.create({
  name: "attributesPreserver",

  addGlobalAttributes() {
    return [
      {
        types: ["bulletList", "orderedList", "fireList", "prosList", "consList"],
        attributes: {
          // Preserve the class attribute
          class: {
            default: null,
            parseHTML: (element) => {
              // Simply preserve the original class attribute for any list
              return element.getAttribute("class") || null;
            },
            renderHTML: (attributes) => {
              if (!attributes.class) {
                return {};
              }

              return {
                class: attributes.class,
              };
            },
          },
        },
      },
    ];
  },
});
